<script>
  import { _ } from "./i18n.js";
  import { Page, Link, Tabs, Tab, Toolbar, Icon } from "framework7-svelte";
  import BottomToolbar from "./Toolbar.svelte";
</script>

<style>
  :global(a.tag) {
    font-size: 0.8rem !important;
  }

  :global(.tag.tab-link-active) {
    font-weight: bold;
  }

  :global(.tag.tueyhom.tab-link-active) {
    color: #0080e4;
  }

  :global(.tag.fuji.tab-link-active) {
    color: #eb72a8;
  }
</style>

<Page>
  <Toolbar tabbar position="top">
    <Link
      tabLink="#All"
      href="/Products/"
      routeTabId="All"
      reloadCurrent={true}
      class="tab-link tag"
      text={$_('product.all')}>
      <Icon icon="icon icon-bottles" />
    </Link>
    <Link
      tabLink="#Tuey"
      href="/Products/Tueyhom"
      routeTabId="Tueyhom"
      reloadCurrent={true}
      class="tag tueyhom"
      text={$_('product.tueyhom')}>
      <Icon icon="icon icon-bottle" />

    </Link>
    <Link
      tabLink="#Fuji"
      href="/Products/Fuji"
      routeTabId="Fuji"
      reloadCurrent={true}
      class="tab-link tag fuji"
      text={$_('product.fuji')}>
      <Icon icon="icon icon-bottle" />
    </Link>
  </Toolbar>
  <Tabs animated routable>
    <Tab
      id="All"
      style="padding-top: 0px; padding-bottom: 0px"
      class="page-content" />
    <Tab
      id="Tueyhom"
      style="padding-top: 0px; padding-bottom: 0px"
      class="page-content" />
    <Tab
      id="Fuji"
      style="padding-top: 0px; padding-bottom: 0px"
      class="page-content" />
  </Tabs>

  <BottomToolbar tabLinkActive={'/Products/'} />
</Page>
